/* Returns an array of year strings from a given year minus yearsBefore to plus yearsAfter */
/* Example: "2024", "2024 - 2025", "2025", "2025-2026" */
export function academicYearOptions({ currentYear, yearsBefore, yearsAfter } : { currentYear: number, yearsBefore: number, yearsAfter: number }): string[] {
    const result = []
    const startYear = currentYear - yearsBefore
    const endYear = currentYear + yearsAfter

    for (let year = startYear; year <= endYear; year++) {
        result.push(year.toString())
        result.push(`${year.toString()} - ${(year+ 1).toString()}`)
    }

    return result
}
